export enum AdvancedSearchEnumInput {
  DRAWING_TYPE = 'type',
  MACHINE_STATUS = 'status',
  MACHINE_EFFICIENCY = 'efficiency',
  PRIORITY = 'priority',
  PRODUCTION_SCHEDULE_STATUS = 'production_order_status'
}
